export default __webpack_public_path__ + "static/media/numbers-tablet.2dfe891c.png";